import { Input as AntInput } from "antd";

export const Input = AntInput;
